import { RatingDisplay } from "@/components/company/rating-display"
import { dataByWorkType } from "@/constants/company/work-type"
import type { WorkTypeMetrics } from "@/helpers/company/work-type-metrics"

function WorkTypeRow({ metrics }: { metrics: WorkTypeMetrics }) {
  const config = dataByWorkType[metrics.workType]

  return (
    <div className="border-border flex items-center gap-4 border p-3">
      <div className="flex h-10 w-10 shrink-0 items-center justify-center">
        <img
          src={config.icon}
          alt={config.name}
          width={40}
          height={40}
          className="h-10 w-10 object-contain"
        />
      </div>
      <div className="min-w-0 flex-1">
        <div className="wb-h6">{config.name}</div>
        <div className="text-muted-foreground text-sm">
          {config.description}
        </div>
      </div>
      <div className="shrink-0 text-right">
        <RatingDisplay value={metrics.adjustedRating} />
      </div>
    </div>
  )
}

export function PerformanceByWorkTypeSection({
  workTypeMetrics,
}: {
  workTypeMetrics: WorkTypeMetrics[]
}) {
  return (
    <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
      {workTypeMetrics.map((metrics) => (
        <WorkTypeRow key={metrics.workType} metrics={metrics} />
      ))}
    </div>
  )
}
